import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import {NavMenu} from "../../components/GetNavMenu";
import {Card, Container, Divider, Space, Table, Text, Title, Loader} from "@mantine/core";
import {Footer} from "../../components/GetFooter";
import React, {useEffect, useState} from "react";
import {useStyles} from "../../models/styles/NotFoundStyle";
import {HTTPError} from "../../models/errors/HTTPError";
import {AccountModel} from "../../models/account/AccountModel";
import {ApiDataHelper} from "../../data/ApiDataHelper";
import {IconIdBadge2, IconMail, IconCalendar, IconKey} from "@tabler/icons";
import {ContainerLoader} from "../../components/loader/ContainerLoader";
import {No2FABanner} from "../../components/warnings/No2FABanner";

export function Account({memory}: SystemMemoryProps) {
    const { classes } = useStyles();

    // Account states
    const [account, setAccount] = useState(<ContainerLoader />);
    const [banner, setBanner] = useState(<></>);

    // Page loading function
    async function LoadAccount() {
        // Load the user's account dashboard
        const Api = new ApiDataHelper({memory: memory});

        let data = undefined;
        try {
            data = await Api.Execute<AccountModel>('/v1/account', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }, true, 120);
        } catch (e) {
            // Check for HttpError
            if (e instanceof HTTPError) {
                // If the user is not signed in, redirect to the login page
                if (e.code === 401) {
                    memory[0].Router('/login');
                } else {
                    // If the error has no method to handle it then throw it
                    throw e;
                }
            } else {
                // If the error is not an HTTPError then throw it
                throw e;
            }
        }

        if (data !== undefined) {
            // Set the account information
            const date = new Date(data.created);
            const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

            let adminborder = {};
            if (data.isAdmin) {
                adminborder = { border: "solid #731818" };
            }

            // If the user doesn't have 2FA enabled, display a warning banner
            if (!data.has2FaEnabled) {
                setBanner(
                    <No2FABanner isAdmin={data.isAdmin}></No2FABanner>
                )
            }

            setAccount(
                <>
                    <Container p={'md'} >
                    <Card shadow="sm" padding="lg" radius="md" withBorder style={adminborder}>
                        <Table highlightOnHover withColumnBorders>
                            <tbody>
                            <tr>
                                <td><Title size={18}><IconMail size={18}/> Email</Title></td>
                                <td><Text size={18}>{data.email}</Text></td>
                            </tr>
                            <tr>
                                <td><Title size={18}><IconIdBadge2 size={18}/> Name</Title></td>
                                <td><Text size={18}>{data.firstName} {data.lastName}</Text></td>
                            </tr>
                            <tr>
                                <td><Title size={18}><IconKey size={18}/> Two Factor Authentication</Title></td>
                                <td><Text size={18}>{data.has2FaEnabled ? "Enabled" : "Disabled"}</Text></td>
                            </tr>
                            <tr>
                                <td><Title size={18}><IconCalendar size={18}/> Joined</Title></td>
                                <td><Text size={18}>{months[date.getMonth()] + " " + date.getFullYear()}</Text></td>
                            </tr>
                            </tbody>
                        </Table>
                        <center><Text p={'sm'}>This table contains basic information about your account on
                            tomsw.uk</Text></center>
                    </Card>
                    </Container>
                </>
            )
        }
    }

    // Load the account information
    useEffect(() => { LoadAccount() }, []);

    return (
        <>
            <NavMenu memory={memory}></NavMenu>
            <center>
                <Space h="lg" />
                {banner}
                <Title order={1} className={classes.title}>Account Information</Title>
                {account}
                <Divider size={5}></Divider><Space h="sm"/>
            </center>
            <Footer data={[]}></Footer>
        </>
    )
}